import { LAYOUT_CONFIG } from '@/constants/layoutConfig';
import useWindowSize from '@/hooks/useWindowSize';

/**
 * 计算容器高度
 * - 减去头部header高度
 * - 减去一级导航navbar高度
 * - 减去二级导航toolbar高度
 * - 减去导航区与内容区之间灰条divider高度
 * - 减去Panel组件的上内边距高度
 * - 减去Panel组件的下内边距高度
 * - 减去Panel组件的Header高度
 */
export default function useContentHeight({
  /**
   * 页面是否包含导航区与内容区之间灰条divider，默认为 true
   */
  withDivider = true,
  /**
   * 页面是否包含二级导航，默认为 false
   */
  withToolBar = false,
  /**
   * 是否包含Panel组件的上内边距，默认为 false
   */
  withPanelPaddingTop = false,
  /**
   * 是否包含Panel组件的下内边距，默认为 false
   */
  withPanelPaddingBottom = false,
  /**
   * 是否包含Panel组件的Header，默认为 false
   */
  withPanelHeader = false,
  /**
   * 是否包含Table组件的Pagination分页器，默认为 false
   * - 分页器高度25 + 上外边距25
   */
  withTablePagination = false,
} = {}): number {
  const { height } = useWindowSize();
  // 头部header + 导航栏navbar
  let header = LAYOUT_CONFIG.PAGE_HEADER_HEIGHT + LAYOUT_CONFIG.PAGE_NAVBAR_HEIGHT;

  if (withDivider) {
    header += LAYOUT_CONFIG.PAGE_DIVIDER_HEIGHT;
  }
  if (withToolBar) {
    header += LAYOUT_CONFIG.PAGE_TOOLBAR_HEIGHT;
  }
  if (withPanelPaddingTop) {
    header += LAYOUT_CONFIG.PANEL_PADDING_TOP;
  }
  if (withPanelPaddingBottom) {
    header += LAYOUT_CONFIG.PANEL_PADDING_BOTTOM;
  }
  if (withPanelHeader) {
    header += LAYOUT_CONFIG.PANEL_HEADER_HEIGHT;
  }
  if (withTablePagination) {
    header += LAYOUT_CONFIG.TABLE_PAGINATION_WITH_MARGIN_HEIGHT;
  }
  return height - header;
}
